import { TabList } from "react-tabs";

function TabListItem({ dataProduct, type, scrollTo }) {
  const hasDescription =
    dataProduct.product_variant_description || dataProduct.product_description;
  const hasFeatures =
    (dataProduct.product && dataProduct.product.features.length > 0) ||
    dataProduct.features?.length > 0;
  const hasRelated =
    (dataProduct.product && dataProduct.product.related.length > 0) ||
    dataProduct.related?.length > 0;
  const hasDeliveryDescription =
    dataProduct.product_variant_delivery_description ||
    dataProduct.product_delivery_description;

  return (
    <TabList className="nav nav-tabs nav-border-anim">
      {hasDescription && (
        <li
          className={`nav-link${type === "description" ? " active" : ""}`}
          onClick={() => scrollTo("description")}
        >
          Opis
        </li>
      )}
      {hasFeatures && (
        <li
          className={`nav-link${type === "features" ? " active" : ""}`}
          onClick={() => scrollTo("features")}
        >
          Dane tech.
        </li>
      )}
      {hasDeliveryDescription && (
        <li
          className={`nav-link${type === "delivery" ? " active" : ""}`}
          onClick={() => scrollTo("delivery")}
        >
          Dostawa
        </li>
      )}
      {hasRelated && (
        <li
          className={`nav-link${type === "relation" ? " active" : ""}`}
          onClick={() => scrollTo("relation")}
        >
          Pasuje do
        </li>
      )}
    </TabList>
  );
}

export default TabListItem;
